export default __webpack_public_path__ + "static/media/averta-bold.8fdcd8d4.woff2";